import React, { useCallback, useEffect, useState } from 'react';
import qs from 'query-string';

import ym from 'react-yandex-metrika';

import cn from 'classnames';
import { DEFAULT_GRADE_INFORMATICS, INFORMATICS_GRADES } from 'common.components/user/user.constants';
import { GradeSelect } from 'common.components/grade-select/grade-select';
import { Text } from '@edu-frontend/modules/src/components/ui/Text';
import { useMedia } from 'react-use';
import { useIntl } from 'react-intl';

import './course-container-widget-v2.scss';
import { useLocation } from 'react-router';
import { useChangeGrade } from 'common.components/grade-select/useChangeGrade';
import { useCurrentTeamGrade } from '../../bundles/lab/utils/use-current-grade';

import { CourseContainerWidgetV2__list } from './__list/course-container-widget-v2__list';

interface CourseContainerWidgetV2Props {
    className?: string;
}
export const CourseContainerWidgetV2 = ({ className }: CourseContainerWidgetV2Props) => {
    const isMobile = useMedia('(max-width: 767px)');
    const intl = useIntl();
    const gradeFromTeam = useCurrentTeamGrade();
    const { search } = useLocation();
    const queryParams = qs.parse(search);
    const queryGrade = queryParams.grade ? Number(queryParams.grade) : null;
    const [selectedGrade, setSelectedGrade] = useState<(typeof INFORMATICS_GRADES)[number]>(
        queryGrade ?? gradeFromTeam ?? DEFAULT_GRADE_INFORMATICS
    );

    const changeGrade = useChangeGrade();

    // устанавливает выбранный грейд в соответствии с query при использовании браузерной "Назад"
    useEffect(() => {
        if (!queryGrade) {
            changeGrade(selectedGrade);
        } else if (queryGrade !== selectedGrade) {
            setSelectedGrade(queryGrade);
        }
    }, [queryGrade, selectedGrade, changeGrade]);

    const onItemClick = useCallback(() => {
        ym('reachGoal', 'teacher_select_coursecontainer,', { from: 'main', grade: selectedGrade });
    }, [selectedGrade]);

    const handleSelectGrade = useCallback(
        (grade: number) => {
            setSelectedGrade(grade);
            changeGrade(grade);
        },
        [changeGrade]
    );

    return (
        <div className={cn('course-container-widget-v2', className)}>
            <Text as="div" typography="titleL">
                {intl.formatMessage({ id: 'courseContainer.widget.header' })}
            </Text>
            <GradeSelect
                grades={INFORMATICS_GRADES}
                onSelectGrade={handleSelectGrade}
                selectedGrade={selectedGrade}
                showEgeTab={true}
                type={isMobile ? 'select' : 'tabs'}
            />
            <CourseContainerWidgetV2__list grade={selectedGrade} onItemClick={onItemClick} />
        </div>
    );
};
